import { TimerPlayIcon } from './TimerPlayIcon';

/**
 * author: Colton Wiscombe
 * id 81E15BC1-262E-435E-82BD-C4342A92D6E1
 * name timer-play
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-play.svg
 * tags
 * - Date / Time 
 */
export const StopwatchPlayIcon = TimerPlayIcon;
export default StopwatchPlayIcon